import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import RecruitmentApp from "@/recruitment/App.jsx";
import ErrorBoundary from "@/components/ErrorBoundary";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <RecruitmentApp />
  </ErrorBoundary>,
);
